import React, { Fragment } from "react"

import PlShiftPrintTemplate from "components/PrintListener/PrinterTemplates/PlShiftPrintTemplate"
import PlTestPrintTemplate from "components/PrintListener/PrinterTemplates/PlTestPrintTemplate"
import PlQrPrintTemplate from "components/PrintListener/PrinterTemplates/PlQrPrintTemplate"
import PlTableMovedPrintTemplate from "components/PrintListener/PrinterTemplates/PlTableMovedPrintTemplate"
import PlCombinedOrdersPrintTemplate from "components/PrintListener/PrinterTemplates/PlCombinedOrdersPrintTemplate"
import PlOrderDeletedPrintTemplate from "components/PrintListener/PrinterTemplates/PlOrderDeletedPrintTemplate"
import PlOrderPrintTemplateForCustomer from "components/PrintListener/PrinterTemplates/PlOrderPrintTemplateForCustomer"
import PlOrderPrintTemplateForKitchen from "components/PrintListener/PrinterTemplates/PlOrderPrintTemplateForKitchen"
import PlOrderItemsPrintTemplate from "components/PrintListener/PrinterTemplates/PlOrderItemsPrintTemplate"
import PlOrderEditedPrintTemplate from "components/PrintListener/PrinterTemplates/PlOrderEditedPrintTemplate"
import classes from "./PvTemplates.module.scss"

const selectedPrinterResolution = 8

const PvTemplates = (props) => {
  const {
    printType,
    printData,
    selectedPaperWidth
  } = props

  const width =
    selectedPaperWidth * selectedPrinterResolution

  return (
    <div className={classes["container"]}>
      <div
        style={{ width: `${width}px` }}
        className={classes["list"]}
      >
        {
          printType === "order" &&
          <Fragment>
            <PlOrderPrintTemplateForCustomer
              printData={printData}
              templateType="thermal"
            />
            <PlOrderPrintTemplateForKitchen
              printData={printData}
              templateType="thermal"
            />
            {printData.thisPrinterOrderItems.map((thisPrinterOrderItem, oiIndex) =>
              <PlOrderItemsPrintTemplate
                key={oiIndex}
                code={printData.code}
                queueNumber={printData.queueNumber}
                tableNumber={printData.tableNumber}
                deliveryType={printData.deliveryType}
                thisPrinterOrderItem={thisPrinterOrderItem}
                templateType="thermal"
              />
            )}
          </Fragment>
        }
        {
          printType === "tableQrCode" &&
          <PlQrPrintTemplate
            printData={printData}
            templateType="thermal"
          />
        }
        {
          printType === "test" &&
          <PlTestPrintTemplate
            templateType="thermal"
          />
        }

        {
          printType === "shift" &&
          <PlShiftPrintTemplate
            printData={printData}
            templateType="thermal"
          />
        }
        {
          printType === "tableMoved" &&
          <PlTableMovedPrintTemplate
            printData={printData}
            templateType="thermal"
          />
        }
        {
          printType === "combinedOrder" &&
          <PlCombinedOrdersPrintTemplate
            printData={printData}
            templateType="thermal"
          />
        }
        {
          printType === "deletedOrder" &&
          <PlOrderDeletedPrintTemplate
            printData={printData}
            templateType="thermal"
          />
        }
        {
          printType === "orderEdited" &&
          <PlOrderEditedPrintTemplate
            printData={printData}
            templateType="thermal"
          />
        }
      </div>
    </div>
  )
}

export default PvTemplates